<h4 mat-dialog-title class="mb-0">
    <div class="dialog-title">
        <span class="line-1">
            {{label}}
        </span>
        <!-- <a class="download mx-2" (click)="downloadFile(all_files[index])" matTooltip="Download" target='_self'>
        Download <i class="mx-1 fa fa-download" aria-hidden="true"></i>
      </a> -->

        <span (click)="close()" style="cursor:pointer;margin-left: auto;float: right;">
            <i class="fa fa-times" aria-hidden="true"></i>
        </span>
    </div>
</h4>

<div class="h-75" mat-dialog-content>
    <!-- <mat-form-field floatLabel="always" class="mat-border-none float-right">
      <mat-label class="req" [title]="label">
        {{label}}
      </mat-label> -->
    <div>
        <div #canvas_container class="canvas-container w-100">
            <div class="mb-2 float-right">
                <span class="badge badge-update-status" (click)="clearCanvas()"
                    [style]="'--background:var(--js-red);' | SanitizePipe : 'style'"> Clear</span>
            </div>
            <ng-container
                *ngIf="(fg.value && fg.value['temp_sign']&& fg.value['temp_sign'][0] && fg.value['temp_sign'][0].cdnPath)">
                <img id="resumeViewer" frameborder="0" style="width: 100%;height: 100%;object-fit: contain;"
                    [src]="(storage_url + (fg.value && fg.value['temp_sign'] && fg.value['temp_sign'][0] && fg.value['temp_sign'][0].cdnPath)) | SafeFilePipe"
                    [title]="fg.value['temp_sign'][0]['fileName']">
            </ng-container>

            <div class="h-100"
                [hidden]="(disabled || (fg.value && fg.value['temp_sign']&&fg.value['temp_sign'][0] && fg.value['temp_sign'][0].cdnPath))">
                <div [hidden]="showBase64">
                    <canvas #canvas DestoryDirective [afterViewInit]="ngAfterViewInitRef" class="w-100 h-100"></canvas>
                </div>
                <img id="resumeViewer" frameborder="0" style="object-fit: contain;" *ngIf="showBase64"
                    [src]="(fg.value && fg.value['temp_sign'] && fg.value['temp_sign'].content) | SafeFilePipe"
                    [title]="fg.value['temp_sign']['fileName']">
            </div>


        </div>

    </div>
    <input matInput class="d-none">
    <!-- </mat-form-field> -->
</div>

<mat-dialog-actions>
    <div class="row">
        <span style="font-size: 13px !important;" id="tm-popup-notification-window"> </span>

        <div class="col-md-12 text-right">
            <button style="min-width: 100px;" class="ml-auto btn-sm blob-btn-cancel btn mx-1 mx-1 tallite-action"
                (click)="close()">
                {{ 'Cancel' | translate}}
                <span class="blob-btn-cancel__inner">
                    <span class="blob-btn-cancel__blobs">
                        <span class="blob-btn-cancel__blob"></span>
                        <span class="blob-btn-cancel__blob"></span>
                        <span class="blob-btn-cancel__blob"></span>
                        <span class="blob-btn-cancel__blob"></span>
                    </span>
                </span>
            </button>
            <!-- <tm-digital-signature [fg]="fg" [height]="120" ['temp_sign']="'sign'"></tm-digital-signature> -->
            <button style="min-width: 100px;" class="blob-btn btn-sm  btn   mx-1 tallite-action my-auto"
                (click)="submit()" type="submit">
                {{'Submit' | translate}}
                <span class="blob-btn__inner">
                    <span class="blob-btn__blobs">
                        <span class="blob-btn__blob"></span>
                        <span class="blob-btn__blob"></span>
                        <span class="blob-btn__blob"></span>
                        <span class="blob-btn__blob"></span>
                    </span>
                </span>
            </button>
        </div>
    </div>
</mat-dialog-actions>

<input #fileInput [accept]="'image/png, image/jpeg'" [readonly]="disabled" [disabled]="disabled? true :false"
    (change)="fileInputChanged($event.target.files)" id="input-file{{id}}" type="file" [multiple]="0"
    style="display:none;">